/**
 * EarlyAccessSideButton — vertical floating tab on the LEFT edge of the
 * screen (mirrors the right-side Chat / Email Support tabs). Links to the
 * public Early Access page. Desktop only; hidden on app/admin/EA routes.
 */
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n';
import { Sparkles } from 'lucide-react';

const HIDDEN_ON = ['/dashboard', '/admin', '/early-access', '/design-preview'];

export default function EarlyAccessSideButton() {
  const { lang } = useLanguage();
  const ja = lang === 'ja';
  const location = useLocation();
  if (HIDDEN_ON.some((p) => location.pathname.includes(p))) return null;

  return (
    <Link
      to={`/${lang}/early-access`}
      data-testid="early-access-side-button"
      aria-label={ja ? '先行受付' : 'Early Access'}
      className="fixed left-0 top-[38%] -translate-y-1/2 z-[9997] hidden lg:flex flex-col gap-1.5 items-center justify-center px-2 py-3.5 rounded-r-xl text-white shadow-lg shadow-purple-500/30 bg-gradient-to-br from-purple-600 to-fuchsia-600 hover:from-purple-700 hover:to-fuchsia-700 hover:px-2.5 transition-all"
    >
      <Sparkles className="w-5 h-5" strokeWidth={2} />
      <span className="text-[11px] font-bold leading-tight tracking-widest uppercase" style={{ writingMode: 'vertical-lr' }}>
        {ja ? '先行受付' : 'EARLY ACCESS'}
      </span>
    </Link>
  );
}
